/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Wed May 08 2024
 **/

import styled from "@emotion/styled";

import { Column } from "@/frameworks/designStuff/components";
import { useChatDataStore } from "@/modules/chat/store";

export const DisabledDimmed = styled.div`
	position: absolute;
	top: 0;
	left: ${() => {
		const showFullSizeChat = useChatDataStore.getState().show_fullsize_chat;
		if (showFullSizeChat) {
			return "60px";
		}
		return 0;
	}};
	width: ${() => {
		const showFullSizeChat = useChatDataStore.getState().show_fullsize_chat;
		if (showFullSizeChat) {
			return "calc(100% - 120px)";
		}
		return "100%";
	}};
	height: 100%;
	z-index: 2;
	background: ${({ theme }) => theme.colors.neutral_00_68};
	border-radius: 0 0 12px 12px;
`;

export const BlockInformationWrapper = styled(Column)<{ variant?: ChatUI.Size }>`
	position: absolute;
	bottom: 100%;
	border-radius: 8px;
	border: 1px solid ${({ theme }) => theme.colors.neutral_30_100};
	background: ${({ theme }) => theme.colors.neutral_00_100};
	width: ${({ variant }) => {
		if (variant === "transparent") return "100%";
		const showFullSizeChat = useChatDataStore.getState().show_fullsize_chat;
		if (showFullSizeChat) {
			return "calc(100% - 120px)";
		}
		return "100%";
	}};
	padding: 8px 16px;
`;
